import { render, staticRenderFns } from "./AddToHomescreen.vue?vue&type=template&id=87056afe&"
import script from "./AddToHomescreen.vue?vue&type=script&lang=js&"
export * from "./AddToHomescreen.vue?vue&type=script&lang=js&"
import style0 from "./AddToHomescreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports